<div class="bg-wrapper password pt-2">
    <main class="password-change container justify-content-center py-5">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="text-center brand py-5">
                    <span
                        ><img src="assets/images/jsw-logo.png" alt="jsw-logo"
                    /></span>
                </div>
                <div class="header text-center">
                    <h3 class="mb-4 text-white">Reset Your Password</h3>
                </div>
                <div class="input-pane py-2">
                    <p class="mb-2 text-white">
                        Enter the vendor code associated with your account and
                        we will send you a link to reset your password.
                    </p>

                    <form
                        [formGroup]="vendorInfo"
                        class="py-4"
                        (ngSubmit)="onResetReq()"
                    >
                        <p *ngIf="isError" class="help-block reset">
                            <span><i class="ri-error-warning-fill"></i></span>
                            {{ sellerName }} is an invald Vendor Code
                        </p>

                        <p *ngIf="isSuccess" class="success-block reset">
                            Password Reset link sent to email
                        </p>
                        <div class="mb-4">
                            <label class="form-label text-white mb-2"
                                >Vendor Code</label
                            >
                            <p
                                class="help-block"
                                *ngIf="
                                    !vendorInfo.get('username')?.valid &&
                                    vendorInfo.get('username')?.touched
                                "
                            >
                                Vendor Code is required
                            </p>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="eg VW123467"
                                formControlName="username"
                            />
                        </div>
                        <div
                            class="loader text-center mt-3 text-white"
                            *ngIf="isLoading"
                        >
                            Loading ...
                        </div>
                        <button
                            [disabled]="vendorInfo.invalid"
                            type="submit"
                            class="btn btn-primary"
                        >
                            Reset Password
                        </button>
                        <button
                            class="btn btn-primary transparent"
                            [routerLink]="['/']"
                        >
                            Return to Login
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </main>

    <footer class="mt-auto d-flex justify-content-center">
        <p>
            Powered by
            <span class="brand-payex"
                ><img src="assets/images/payex-logo.png" alt="PayExLogo"
            /></span>
        </p>
    </footer>
</div>
